import DatePicker from 'componets/date-picker/date-picker';

export default DatePicker;
